/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */

const BarChart = () => {
	return (
		<svg width='24' height='24' viewBox='0 0 80 80'>
			<rect fill='#fea58e' x='0' y='0' width='80' height='14'></rect>
			<rect fill='#51d3d9' x='0' y='20' width='62' height='14'></rect>
			<rect fill='#bda9ea' x='0' y='40' width='49' height='14'></rect>
			<rect fill='#f5c78e' x='0' y='60' width='30' height='14'></rect>
		</svg>
	);
};

export default BarChart;
